import type { HTMLAttributes, ReactNode } from 'react';

type CardSize = 'tight' | 'normal' | 'loose';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  size?: CardSize;
  hover?: boolean;
};

export function Card({ size = 'normal', hover, className, children, ...rest }: CardProps) {
  const classes = ['ui-card'];
  if (size === 'tight') classes.push('ui-card-tight');
  if (size === 'loose') classes.push('ui-card-loose');
  if (hover) classes.push('ui-card-hover');
  if (className) classes.push(className);
  return (
    <div className={classes.join(' ')} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader({ children }: { children: ReactNode }) {
  return <div className="ui-card-header">{children}</div>;
}

export function CardTitle({ children }: { children: ReactNode }) {
  return <h3 className="ui-card-title">{children}</h3>;
}

export function CardDesc({ children }: { children: ReactNode }) {
  return <p className="ui-card-desc">{children}</p>;
}
